import React, { useEffect, useMemo, useState } from "react";
import "bootstrap";
import { TrainingAPI } from "../../api/TrainingAPI";
import "bootstrap/dist/css/bootstrap.min.css";

import infoImage from "../../Images/info-icon.svg";
import { FaFirstAid } from "react-icons/fa";
import { FooterComponent } from "../Footer";
import { Navbar } from "../Navigation/Navbar";
import {
  DatePicker,
  Popconfirm,
  Button,
  Layout,
  Switch,
  Spin,
  Row,
  Col,
  Checkbox,
  Typography,
  Badge,
} from "antd";
import { audioMessage as message } from '../Common/Notifications/audioMessage';
import { HelpButton } from "../Common/HelpButton";

import { FileTwoTone } from "@ant-design/icons";
import moment from "moment";
import { ACWRTable } from "./ACWRTable";
import { CalendarView } from "./CalendarView/CalendarView";

import "../../Styles/styles-Overview.css";

import LevelsOfBuckets from "../../Images/levelsOfBuckets.png";
import Joyride, { STATUS } from "react-joyride";
import { useSelector, useDispatch } from "react-redux";
import { getYearDataV2 } from "../../store/actions/calendar.actions";
import { getTeamDrillCostPerMin, getTeamRestTravelDates } from "../../store/actions/team.actions";
import { PositionSelect } from "../PositionSelect/PositionSelect";

const { Footer } = Layout;
const { Text } = Typography;

const contentMap = (str, acwr_lower, acwr_upper) => {
  switch (str) {
    case "Accel Decel":
      return (
        <div className="main_text">
          <span className="start_text"> Accel Decel,</span> Volume - total
          number of accelerations and decelerations. Some systems allow for
          total number of accel and decel in three separate threshold zones
          (High, Med, Low). We advise looking at the higher intensity
          accelerations and decelerations as those impose a bigger load on your
          athletes.
        </div>
      );
    case "Distance":
      return (
        <div className="main_text">
          <span className="start_text"> Distance</span> is the overall distance
          covered during a session, typically displayed as miles or kilometers
          <ul className="list_items">
            <li>
              Distance Per minute (Metres per minute (m/min), Miles per minute
              (miles/min), Yards per minute (yd/min), Intensity - Distance per
              min allows for coaches to gauge the intensity of a session based
              on distance covered. Distance/Session Duration
            </li>
          </ul>
        </div>
      );
    case "Player Load":
      return (
        <div className="main_text">
          <span className="start_text"> Player Load,</span> Volume - Player Load
          is the sum of the accelerations across all axes of the internal
          tri-axial accelerometer during movement. It takes into account
          instantaneous rate of change of acceleration and divides it by a
          scaling factor (divided by 100).
          <ul className="list_items">
            <li>
              Playerload Permin, Intensity - Playerload perminute allows for
              coaches to gauge the intensity of the training session based on
              playerload. Playerload/Session Durations
            </li>
          </ul>
        </div>
      );
    case "Sprint Distance":
      return (
        <div className="main_text">
          <span className="start_text">Sprint Distance,</span> Volume - Sprint
          Distance is total yards covered above a ‘speed threshold’. Depending
          on systems, this threshold can vary but typically any speed achieved
          about 12mph is considered ‘sprint distance’. Usually the sum of Zone 4
          and Zone 5.
          <ul className="list_items">
            <li className="main_list">
              Sprint distance permin, Intensity - The average sprint distance
              covered per minute of the session.
            </li>
            <li className="main_list">
              Max Speed, Intensity - top speed as the maximum speed sustained
              for at least half a second. Duration may vary with your hardware
              system.
            </li>
          </ul>
        </div>
      );
    case "readiness_ACWR":
      return (
        <div className="main_text">
          <span className="start_text">Readiness</span> - Readiness uses your
          athletes’ subjective data (Wellness and RPE) to provide insight into
          their sleep and recovery and the impact on their ability to perform at
          their best level. If your team fills out daily wellness
          questionnaires, this column will be green if their wellness score is
          above 60, red if it is 60 or below, and yellow if they have not
          completed their questionnaire for the day. A wellness score below 50
          will automatically make that player’s overall score red. If your team
          is not completing a wellness survey this column will represent the
          ACWR of each player’s session RPE (sRPE). sRPE = RPE x Duration
        </div>
      );
    case "readiness_in ":
      return (
        <div className="main_text">
          <span className="start_text">Readiness</span> - Readiness uses your
          athletes’ subjective data (Wellness and RPE) to provide insight into
          their sleep and recovery and the impact on their ability to perform at
          their best level. If your team fills out daily wellness
          questionnaires, this column will be green if their wellness score is
          above 60, red if it is 60 or below, and yellow if they have not
          completed their questionnaire for the day. A wellness score below 50
          will automatically make that player’s overall score red. If your team
          is not completing a wellness survey this column will represent the
          ACWR of each player’s session RPE (sRPE). sRPE = RPE x Duration
        </div>
      );
    case "overall":
      return (
        <div className="main_text">
          <span className="start_text">Overall</span> - This combines your Key
          Metrics and Readiness to assign an overall score for each of your
          athletes. It takes an average of the ACWR for each. If a player’s
          wellness score for the day is below 50, this column will be red even
          if the ACWR of their Key Metrics is in line. It provides an easy way
          to summarize all the data on each of your athletes.
        </div>
      );
    case "weekly":
      return (
        <div>
          <p className="weekly-text">
            The weekly buckets are designed to help coaches understand how
            “full” each metric is according to their weekly loads{" "}
          </p>

          <div className="levels-container">
            <div>
              <img src={LevelsOfBuckets} alt="levels of Buckets" />
            </div>
            <div>
              <p className="buckets-levels-text1">100% - Bucket is FULL</p>
              <p className="buckets-levels-text2">50% - Bucket is Half-Full</p>
              <p className="buckets-levels-tex3">0% - Bucket is Empty</p>
            </div>
          </div>
        </div>
      );
    case "acwr":
      return (
        <div className="moadal-main-container">
          <p>
            Acute to Chronic Workload Ratio: (ACWR) This ratio compares a
            player’s acute load (last 7 days) to their chronic load (21 days
            prior). The calculation takes the average load over the last 7 days
            divided by the average load over the 21 days before that. The sweet
            spot for the ratio is between {acwr_lower} and {acwr_upper}.
          </p>
          <div className="modal-lagends-wrapper wrapper-container-1">
            <span></span>
            <p>Overworked ACWR &gt;{acwr_upper} </p>
          </div>
          <div className="modal-lagends-wrapper wrapper-container-2">
            <span></span>
            <p>Underworked ACWR &lt;{acwr_lower} </p>
          </div>
          <div className="modal-lagends-wrapper wrapper-container-3">
            <span></span>
            <p>
              Sweet Spot ACWR {acwr_lower} - {acwr_upper}{" "}
            </p>
          </div>
          <div className="modal-lagends-wrapper wrapper-container-4">
            <FaFirstAid className="injury-icon-popout" size={40} />
            <p>Injured </p>
          </div>
          <div className="modal-lagends-wrapper wrapper-container-4">
            <FaFirstAid className="injury-icon-popout-yellow" size={40} />
            <p>Return to Play </p>
          </div>
        </div>
      );
    case "Sprints":
      return (
        <div className="main_text">
          <span className="start_text">Sprint,</span> Volume - are the number of
          times that an athlete's velocity enters into zone 4 (7m/s or 15mph )
          or above for at least 2 seconds. This metric can vary depending on the
          hardware.
        </div>
      );
    case "On Ice Load":
      return (
        <div className="main_text">
          <span className="start_text">On Ice Load (Hockey),</span> Volume -
          total accumulated player load above 0.3 threshold.
          <ul className="list_items">
            <li className="main_list">
              On Ice Load Average (Hockey), Volume - average accumulated player
              load above the PL threshold of 0.3 (Total Load - Band 1)
            </li>
            <li className="main_list">
              On Ice Load/per min (Hockey), Intensity - Playerload above the
              rest load threshold (Sum PL Band 2+)/(total minutes - PL Band 1
              Minutes)
            </li>
            <ul>
              <span className="start_text">Player Load Bands Ice Hockey:</span>
              <li>
                0-0.3 = Rest Load (captures sitting on bench and coasting around
                the ice
              </li>
              <li>0.3-0.6 = Low Movement Load</li>
              <li>0.6-0.8 = Medium Movement Load</li>
              <li>1.8+ = High Movement Load</li>
            </ul>
          </ul>
        </div>
      );
    case "Pace (distance > 80% Max Vel)":
      return (
        <div className="main_text">
          <span className="start_text">
            Pace (distance {">"} 80% Max Velocity) (hockey)
          </span>
          Intensity
          <ul className="list_items">
            <li className="main_list">
              High Metabolic Load Distance (STATSports), volume - HMLD which
              measures the total amount of high speed running an athlete does,
              coupled with the total distance of accelerations and decelerations
              throughout a session
            </li>
            <li className="main_list">
              Dynamic Stress Load Fatigue Index (STATSports) - DSL accounts for
              the forces and impacts placed through the feet when running - good
              indicator of fatigue. It’s vital to recognise that your DSL score
              cannot be compared to other athletes – it’s a personal score for
              you to monitor.
            </li>
          </ul>
        </div>
      );
    case "Deceleration":
      return (
        <div className="main_text">
          <span className="start_text">Deceleration,</span>Volume -
          Decelerations are the number of times that an athlete's deceleration
          is greater than the acceleration threshold for at least 1 second.
          Please note that the deceleration thresholds differ between hardware
          systems. There also may be different criteria regarding what is
          ‘classified’ as a deceleration based on ‘duration’ of the action. Some
          systems also provide High, Medium and Low ‘bands’ for deceleration
          thresholds. We advise looking at the higher intensity decelerations as
          those impose a bigger load on your athletes.
          <ul className="list_items">
            <li className="main_list">
              Deceleration permin, Intensity - The average number of
              deceleration efforts per minute of the session.
            </li>
          </ul>
        </div>
      );
    case "Hard Runs":
      return (
        <div className="main_text">
          <span className="start_text">Hard Runs,</span>Volume - Hard Runs would
          be count and distance above 4.5 m/s or 10.1 mph for a duration of 1
          second.
        </div>
      );
    case "Acceleration":
      return (
        <div className="main_text">
          <span className="start_text">Acceleration,</span>Volume -
          Accelerations are the number of times that an athlete's acceleration
          is greater than the acceleration threshold for at least 1 second.
          Please note that the acceleration thresholds differ between hardware
          systems. There also may be different criteria regarding what is
          ‘classified’ as an acceleration based on ‘duration’ of the action.
          Some systems also provide High, Medium and Low ‘bands’ for
          acceleration thresholds. We advise looking at the higher intensity
          accelerations as those impose a bigger load on your athletes.
          <ul className="list_items">
            <li className="main_list">
              Acceleration permin, Intensity - The average number of
              acceleration efforts per minute of the session.
            </li>
          </ul>
        </div>
      );
    case "High Speed Running":
      return (
        <div className="main_text">
          <span className="start_text">High Speed Running,</span>Volume - a
          variable metric that is different across hardware systems, along with
          being ‘adjustable’ by the user - typically, This is the distance that
          you have covered over 5.5m/s (19.8km/h or around 12mph).
        </div>
      );
    case "Trimp":
      return (
        <div className="main_text">
          <span className="start_text">TRIMP,</span>Intensity - TRIMP (aka
          Training Impulse) considers the intensity (calculated by the heart
          rate reserve method) and the duration of exercise (measured in
          minutes). It is a way to quantify training load and stress placed on
          an athlete/player and is represented by a single number.
          <ul className="list_items">
            <li className="main_list">
              <span className="start_text">Heart rate load, Intensity -</span>
              Heart rate load, Intensity - a weighted average of the time spent
              in each heart rate zone. There is a higher weighting given to the
              higher zones.
            </li>
            <li>
              <span className="start_text">Time in Red Zone, Intensity</span>-
              Percentage time in Heart Rate red zone is the total amount of time
              that heart rate was above 85% of the player's assigned Maximum
              Heart Rate. This is displayed as a percentage of the entire
              duration of the whole session. Some systems may use ‘higher’
              percentages of maximum heart rate, so, be aware of your hardware
              companies settings.
            </li>
            <ul className="list_items">
              <li className="main_list">
                Zone 1 - a heart rate zone that consists of ‘very light’
                activity - typically between 50-60% of max heart rate
              </li>
              <li>
                Zone 2 - a heart rate zone that consists of ‘light’ activity -
                typically between 60-70% of max heart rate
              </li>
              <li>
                Zone 3 -a heart rate zone that consists of ‘moderate’ activity -
                typically between 70-80% of max heart rate
              </li>
              <li>
                Zone 4 - a heart rate zone that consists of ‘hard’ activity -
                typically between 80-90% of max heart rate
              </li>
              <li>
                Zone 5 - a heart rate zone that consists of ‘maximal’ activity -
                typically between 90-100% of max heart rate
              </li>
              <li>Some ‘zones’ may vary depending on your Heart Rate System</li>
            </ul>
          </ul>
        </div>
      );
    default:
      return <div>Info coming soon!</div>;
  }
};

export const Overview = (props) => {
  const dispatch = useDispatch();
  const {
    positions,
    info: { display_name: teamName, coach_list: coachList, acwr_lower_limit: ACWRLowerLimit, acwr_upper_limit: ACWRUpperLimit },
  } = useSelector(({ team }) => team);
  const {
    currentUser: { email: currentUserEmail },
  } = useSelector(({ auth }) => auth);
  const { data } = useSelector(({ calendar }) => calendar);
  const [selectedEmails, setSelectedEmails] = useState({});
  const [loading, setLoading] = useState(false);
  const [calendarLoading, setCalendarLoading] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState(undefined);
  const [showTablePopout, setShowTablePopout] = useState(false);
  const [tablePopoutContent, setTablePopoutContent] = useState(null);
  const [showWellnessEmailButton, setWellnessEmailButton] = useState(true);
  const [run, setRun] = useState(true);
  const [acwrLowerLimit, setacwrLowerLimit] = useState(0.8);
  const [acwrUpperLimit, setacwrUpperLimit] = useState(1.3);
  const [surveyResponseCount, setSurveyResponseCount] = useState(undefined);

  const steps = useMemo(
    () => [
      {
        content: <h2>We introduced new functionalities, let's review them!</h2>,
        locale: { skip: <strong aria-label="skip">SKIP</strong> },
        placement: "center",
        target: ".outer-navbar",
      },
      {
        content:
          "Informational pop-ups have been incorporated throughout the “Overview” page to help explain various features, colors, metrics and symbols. If you require more information, please contact your GPS DataViz representative.",
        placement: "left",
        styles: {
          options: {
            width: 300,
          },
        },
        spotlightPadding: 5,
        disableScrolling: true,
        target: ".overall img",
      },
      {
        content:
          "Each box in the calendar now shows how close the session is to the next bucket above or below. If a session is green but nearing the threshold for yellow, the box is nearly completely full of green, with just a small gap at the top. If a session is yellow but barely higher than green, it shows just a little yellow at the bottom. This allows you to quickly differentiate between sessions that fall in the same colored bucket.",
        placement: "right",
        styles: {
          options: {
            width: 300,
          },
        },
        disableScrolling: true,
        target:
          ".calender>div:nth-child(2)>div>div>table>tbody>tr:nth-child(2)>td:nth-child(5)>div>div:nth-child(2)>button",
      },
      {
        content:
          "The first row of the ACWR section now shows the team’s ACWR in each key metric, allowing you to quickly assess the readiness of individual players as well as your team as a whole.  The acute number on the left represents your team’s daily average load in that metric over the last 7 days, also represented by the outside yellow dial. The chronic number on the right represents your team’s daily average load in that metric over the 21 days prior to the last 7 (days 28-8), also represented by the inside green dial.  The ACWR number in the middle is the ratio of your acute to chronic averages.",
        placement: "left",
        styles: {
          options: {
            width: 300,
          },
        },
        disableScrolling: true,
        target: ".acwr-table>div>div>div>div>div>table>tbody>tr:nth-child(1)",
      },
      {
        content:
          "The new toggle above the ACWR section allows you to use this section to see your players’ cumulative weekly load in each of their key metrics.  This allows you to better gauge the readiness of your athletes and plan practice sessions around your upcoming games, ensuring athletes reach/don’t exceed certain key thresholds.  The weekly total is currently set as 2.5x your team baseline in that metric, and you will soon be able to adjust this multiple if you choose to.",
        placement: "bottom",
        styles: {
          options: {
            width: 300,
          },
        },
        disableScrolling: true,
        target: ".weekly_toggle_class",
      },
      {
        content: (
          <div>
            <p>
              The new tiles below your calendar allow you to easily compare
              current metrics to prior metrics. This applies to all metrics your
              team is currently tracking. The toggle and date bar above the
              tiles dictate the changes shown. The date bar defaults to today,
              but you can compare for any prior day and view how loads compared.
              The toggle allows you to compare different time periods:
            </p>
            <ol>
              <li>TODAY- Compares today to same day of the week last week</li>
              <li>
                WEEK- Compare the week so far to same days last week (if today
                is Thursday, comparing the cumulative totals from
                Monday-Thursday this week to Monday-Thursday last week)
              </li>
              <li>
                7 DAYS- Compare the last 7 days cumulative loads to the prior 7
                days cumulative loads
              </li>
              <li>
                MONTH- Compare the month so far to last month same period (if
                today is the 23rd, comparing the cumulative loads from days 1-23
                this month to days 1-23 last month)
              </li>
              {/* <li>GAME DAY- Compare today’s training or game to the last training or game that matches (if today is GameDay -2 it will compare to your prior GameDay -2)</li> */}
            </ol>
          </div>
        ),
        placement: "bottom",
        styles: {
          options: {
            width: 600,
          },
        },
        target: ".metric_dropdown_tiles",
      },
    ],
    []
  );
  const dateFormat = "YYYY-MM-DD";

  const trainingAPI = useMemo(() => new TrainingAPI(), []);

  const fetchCalendarData = async () => {
    setCalendarLoading(true);
    let curr_date = moment();
    let start_date = curr_date.startOf('month').format('MM/DD/YYYY');
    let end_date = curr_date.endOf('month').format('MM/DD/YYYY');
    await dispatch(getYearDataV2(start_date, end_date, setCalendarLoading));
    // props.cal_data_got(); //commented the line for now in case we want to have the data reload flag back
  };

  useEffect(() => {
    fetchCalendarData();
  }, []);

  useEffect(() => {
    if (!props.date) {
      message.error("Please select valid date to generate the report");
      return;
    }

    dispatch(getTeamDrillCostPerMin());
    props.acwr_get({ weekly: props.show_weekly });

    setacwrUpperLimit(ACWRUpperLimit);
    setacwrLowerLimit(ACWRLowerLimit);
    let featureIntro = localStorage.getItem("feature_intro");
    if (featureIntro && featureIntro === "false" && run === true) {
      setRun(false);
    }

    trainingAPI
      .surveyreponsecount(props.date)
      .then((data) => setSurveyResponseCount(data))
      .catch((err) => {
        console.log(err);
        setSurveyResponseCount(undefined);
      });
  }, [props.show_weekly, props.date]);

  // useEffect(() => {
  //   let temp = { weekly: props.show_weekly ? "true" : "false" };
  //   if (selectedPosition) {
  //     temp["position_id"] = selectedPosition;
  //   }
  // }, [props.show_weekly, selectedPosition, props.date]);

  const positionChange = (e) => {
    setSelectedPosition(e);
  };

  const sendWellnessEmail = () => {
    if (!props.date) {
      message.error("Please select valid date to generate the report");
      return;
    }

    let emails = Object.keys(selectedEmails).filter(
      (key) => selectedEmails[key] === true
    );
    if (emails.length == 0) {
      message.info("Please select at least one email recipient for the report");
      return;
    }

    setLoading(true);

    trainingAPI
      .wellnessEmail(props.date, emails)
      .then((data) => {
        setLoading(false);
        message.success("Email Sent!");
      })
      .catch((data) => {
        setLoading(false);
        message.error("Error sending email.");
      });
  };

  const displayTablePopout = (str) => {
    setTablePopoutContent(contentMap(str, acwrLowerLimit, acwrUpperLimit));
    setShowTablePopout(true);
  };

  const handleJoyrideCallback = (data) => {
    const { status, type } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      localStorage.setItem("feature_intro", false);
      setRun(false);
    }
  };

  const onChangeEmailSelection = (option) => {
    setSelectedEmails({ ...selectedEmails, [option]: !selectedEmails[option] });
  };

  const handleWellnessNotification = () => {
    trainingAPI
      .sendWellnessNotification(props.date)
      .then((data) => {
        setLoading(false);
        message.success(data);
      })
      .catch((data) => {
        setLoading(false);
        message.error(data);
      });
  };

  const handleRPENotification = () => {
    trainingAPI
      .sendRPENotification(props.date)
      .then((data) => {
        setLoading(false);
        message.success(data);
      })
      .catch((data) => {
        setLoading(false);
        message.error(data);
      });
  };


  const sendNotificationButtons = (
    <>
      <hr />
      <Row gutter={[0, 8]} align="middle">
        <Col span={12}>
          <Button
            className="survey-count-button"
            type="primary"
            onClick={handleWellnessNotification}
          >
            Send <br />
            <b>Wellness survey</b>
            <br /> notification
            <br />
            {/* <Tag icon={<CheckCircleOutlined />} color="geekblue" bordered={true}>{`${(surveyResponseCount?.wellness?.filter(x=>x.submitted===true) || []).length} / ${surveyResponseCount?.wellness?.length || 0}`}</Tag> */}
            <Badge
              color="geekblue"
              count={`${
                (
                  surveyResponseCount?.wellness?.filter(
                    (x) => x.submitted === true
                  ) || []
                ).length
              } / ${surveyResponseCount?.wellness?.length || 0}`}
            />
          </Button>
        </Col>

        <Col span={12}>
          <Button
            className="survey-count-button"
            type="primary"
            onClick={handleRPENotification}
          >
            Send <br />
            <b>RPE survey</b>
            <br />
            notification
            <br />
            <Badge
              color="geekblue"
              count={`${
                (
                  surveyResponseCount?.rpe?.filter(
                    (x) => x.submitted === true
                  ) || []
                ).length
              } / ${surveyResponseCount?.rpe?.length || 0}`}
            />
          </Button>
        </Col>
      </Row>
      <hr />
    </>
  );

  return (
    <>
      <Joyride
        callback={handleJoyrideCallback}
        continuous
        hideCloseButton
        run={run}
        scrollToFirstStep
        showSkipButton
        steps={steps}
        styles={{
          options: {
            zIndex: 10000,
          },
        }}
      />
      <Navbar />
      <HelpButton page="Overview"/>
      <div className="overview-content" style={{ position: "relative" }}>
        <ul className="overview-grid">
          <li className="overview-calendar">
            <div className="search-divider"></div>
            <div className="overview-warraper-container">
              {data !== null ? (
                <CalendarView overviewChange={props.onCalenderToggle} loading={calendarLoading} setLoading={setCalendarLoading}/>
              ) : (
                <></>
              )}
            </div>
          </li>
          <li className="overview-graph">
            <div className="search-divider"></div>
            <div className="" style={{ position: "relative" }}>
              <div className="pop-up-modal-containers-wrapper">
                <div className="ACWR-table-date-picker">
                  <PositionSelect
                    value={selectedPosition}
                    handleChange={positionChange}
                    options={positions}
                    width="8vw"
                  />
                  <div
                    style={{ display: "flex", direction: "row", gap: "5px" }}
                  >
                    <div className="placeholder-container">
                      <img
                        src={infoImage}
                        alt="inof-img"
                        style={{ cursor: "pointer" }}
                        onClick={() => displayTablePopout("acwr")}
                      />
                      <span className="placeholder-label">ACWR</span>
                    </div>

                    <Switch
                      className={"weekly_toggle_class".concat(
                        " ",
                        props.show_weekly ? "checked" : "unChecked"
                      )}
                      defaultChecked={props.show_weekly}
                      onChange={props.toggle_overview_show_weekly}
                    ></Switch>
                    <div className="placeholder-container">
                      <img
                        src={infoImage}
                        alt="inof-img"
                        style={{ cursor: "pointer" }}
                        onClick={() => displayTablePopout("weekly")}
                      />

                      <span className="placeholder-label">Weekly Buckets</span>
                    </div>
                  </div>

                  <DatePicker
                    onChange={props.onDateChange}
                    value={
                      props.date !== null
                        ? moment(props.date, dateFormat)
                        : null
                    }
                  />

                  {showWellnessEmailButton ? (
                    <Popconfirm
                      placement="bottom"
                      onConfirm={sendWellnessEmail}
                      icon={<FileTwoTone />}
                      okText="Yes"
                      cancelText="No"
                      title={
                        <>
                          <Text>
                            Would you like to generate a detailed report?
                            <br />
                          </Text>
                          {sendNotificationButtons}
                          <div>
                            Please select the emails that should receive the
                            report:
                          </div>

                          <Col style={{ marginTop: "0.5em" }}>
                            {coachList
                              ?.filter((x) => x.email == currentUserEmail)
                              ?.map((item, index) => (
                                <Row key={`row_${index}`}>
                                  <Checkbox
                                    checked={
                                      selectedEmails[item.email] || false
                                    }
                                    onChange={() =>
                                      onChangeEmailSelection(item.email)
                                    }
                                  >
                                    {item.first_name} {item.last_name}{" "}
                                    <span style={{ fontSize: 13 }}>
                                      ({item.email})
                                    </span>
                                  </Checkbox>
                                </Row>
                              ))}
                            {coachList
                              ?.filter((x) => x.email != currentUserEmail)
                              ?.map((item, index) => (
                                <Row key={`coachlistrow_${index}`}>
                                  <Checkbox
                                    checked={
                                      selectedEmails[item.email] || false
                                    }
                                    onChange={() =>
                                      onChangeEmailSelection(item.email)
                                    }
                                  >
                                    {item.first_name} {item.last_name}{" "}
                                    <span style={{ fontSize: 13 }}>
                                      ({item.email})
                                    </span>
                                  </Checkbox>
                                </Row>
                              ))}
                          </Col>
                        </>
                      }
                    >
                      <Button className="send-wellness-button" type="primary">
                        Get Wellness Report
                      </Button>
                      {loading && (
                        <span style={{ padding: "10px" }}>
                          <Spin size="large" />
                        </span>
                      )}
                    </Popconfirm>
                  ) : null}
                </div>
              </div>

              {props.acwr_data !== null ? (
                <ACWRTable
                  date={props.date}
                  getData={props?.acwr_get}
                  data={props.acwr_data}
                  showWeekly={props.show_weekly}
                  span={20}
                  tablePopoutContent={tablePopoutContent}
                  showTablePopout={showTablePopout}
                  setShowTablePopout={setShowTablePopout}
                  displayTablePopout={displayTablePopout}
                  ACWR_UPPER={acwrUpperLimit}
                  ACWR_LOWER={acwrLowerLimit}
                  team_name={teamName}
                  loading={props.loading}
                  position_filter={selectedPosition}
                />
              ) : (
                <></>
              )}
            </div>
          </li>
        </ul>
      </div>
      <FooterComponent/>
    </>
  );
};
